// extracted by mini-css-extract-plugin
module.exports = {"info":"info_info__rwsdE","app":"info_app__hyeN8","infoWrapper":"info_infoWrapper__wWard","content":"info_content__DzgmJ"};